import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./WelcomeMentorshipPage.scss";
import { MobileLogo } from "assets/images";
import { decryptData, errorResponse, failResponse } from "config/config";
import { getMentorDecryptdetails } from "services/home";
import useCookie from "hooks/useCookie";
import { getBrowserName } from "config/utils";
import { getOSDetail } from "config/utils";
import { getUserIp } from "services/third-party";


const WelcomeMentorshipPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encryptedData = queryParams.get("params");
  const { setCookie, removeCookie } = useCookie();
  const [userData, setUserData] = useState({});



  const getEncryptedDetails = async () => {
    try {
      const { data: ip } = await getUserIp();
      const res = await getMentorDecryptdetails({
        encryptedstring: encryptedData,
        device: "Web",
        platformType: getBrowserName(),
        os: getOSDetail(),
        IPaddress: ip.ip,
      });

      if (res.code === 200) {
        setUserData({ ...res.data } || {});
        setCookie(res.data?.accessToken);

        // Navigate after 2 seconds
        setTimeout(() => {
          navigate("/dashboard/mentorship-course-selection");
        }, 2000);
      } else {
        navigate("/login")
      }
    } catch (err) {
      errorResponse(err);
    }
  };


  React.useLayoutEffect(() => {
    getEncryptedDetails();
  }, []);

  const handleNavigate = () => {
    navigate("/dashboard/mentorship-course-selection");
  };

  return (
    <div className="welcome-page d-flex align-items-center justify-content-center">
      <div className="welcome-card text-center">
        <img src={MobileLogo} alt="Logo" className="welcome-logo mb-3" />
        <h1 className="mb-3">Welcome to Mentorship</h1>
        <p className="mb-4">
          Start your journey towards guided learning and personal growth.
        </p>
        {/* <button className="btn btn-primary" onClick={handleNavigate}>
          Go to Mentorship
        </button> */}
      </div>
    </div>
  );
};

export default WelcomeMentorshipPage;
